import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { faFile, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, CircularProgress, InputLabel, MenuItem, Select, styled, TextField, } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import moment from "moment";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import api from "../../services/api";
import { ToastContainer, toast } from "react-toastify";
import { baseAnexosURL, customPtBRText, decodeUtf8, downloadURI, getFileExtension, getFileName } from "../../functions/utils";
import { DataGrid } from "@mui/x-data-grid";
import Footer from "../../components/footer/footer";
const Publicar = () => {
    const [nomeFile, setNomeFile] = useState("");
    const [tipoArquivo, settipoArquivo] = useState("ppa");
    const [dataInicial, setDataInicial] = useState(new Date().toDateString());
    const [selectedFile, setSelectedFile] = useState();
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState();
    const [getFiles, setGetFiles] = useState(true);
    const [inPageFilter, setInPageFilter] = useState("");
    const [filterData, setFilterData] = useState([{}]);
    const [pageSize, setPageSize] = useState(10);
    const [disableButtons, setDisableButtons] = useState(false);
    const [warningMessage, setWarningMessage] = useState("");
    const { user, windowDimensions, backGroundColor, orgaoAUsar } = useContext(UserContext);
    useEffect(() => {
        if (getFiles && user.orderNo) {
            api
                .get("/file", {
                params: {
                    user: user.orderNo,
                },
            })
                .then((response) => {
                const formatData = [];
                response.data.map((file) => {
                    const formatreg = {
                        id: file.ID,
                        fileURL: baseAnexosURL + file.FILE,
                        fileName: file.NOME_EXIBE ? decodeUtf8(file.NOME_EXIBE) : decodeUtf8(getFileName(file.FILE)),
                        municipioId: file.MUNICIPIO_ID,
                        extensao: getFileExtension(file.FILE),
                        ano: file.YEAR,
                        tipo: file.DESCRICAO,
                    };
                    formatData.push(formatreg);
                });
                setData(formatData);
                setFilterData(formatData);
                setLoading(false);
                setGetFiles(false);
            });
        }
    }, [getFiles, user.orderNo]);
    useEffect(() => {
        setDisableButtons(true);
        setNomeFile("");
        setSelectedFile(undefined);
        switch (tipoArquivo) {
            case "patrimonio":
                setWarningMessage(`A publicação de patrimônio é feita pelo aplicativo PATRIMONIO X5, para maiores informações <a href="https://www.fenix.com.br/ftp/patrimoniox5/HTML/publicacao-do-anexo-pdf-no-por.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "patrimonioImovel":
                setWarningMessage(`A publicação de patrimônio Imóvel é feita pelo aplicativo PATRIMONIO X5, para maiores informações <a href="https://www.fenix.com.br/ftp/patrimoniox5/HTML/sinc_obras_portal_transparencia.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "balancete":
                setWarningMessage(`A publicação do balancete financeiro é feita pelo aplicativo GERENCIAL, para maiores informações <a href="https://www.fenix.com.br/ftp/gerencial/HTML/publicacao_anexos_dcasp_portal.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            case "programa":
                setWarningMessage(`A publicação de programas e ações é feita pelo aplicativo CONTAB, para maiores informações <a href="https://www.fenix.com.br/ftp/contab2010/HTML/publicacao_pdfs_portal.htm" target="_blank">Clique Aqui</a>`);
                setDisableButtons(true);
                break;
            default:
                setDisableButtons(false);
                setWarningMessage("");
                break;
        }
    }, [tipoArquivo]);
    const handleUpload = () => {
        // Create an object of formData
        const formData = new FormData();
        // Update the formData object
        if (selectedFile !== undefined) {
            formData.append("file", selectedFile);
        }
        setLoading(true);
        // Request made to the backend api
        // Send formData object
        api
            .post("/file", formData, {
            params: {
                orderNo: user.orderNo,
                ano: moment(dataInicial).format("YYYY"),
                tipo: tipoArquivo,
                nomeExibe: nomeFile,
            },
            headers: {
                "Content-Type": "multipart/form-data",
            },
        })
            .then(() => {
            toast.success("Publicação de Arquivo feita com sucesso", { draggablePercent: 60 });
            setNomeFile("");
            setSelectedFile(undefined);
            setLoading(false);
            setGetFiles(true);
        })
            .catch((error) => {
            toast.error(error, { draggablePercent: 60 });
        });
    };
    const handleDownload = (params) => {
        downloadURI(params.fileURL);
    };
    const handleDelete = (params) => {
        api
            .delete("/file", {
            params: {
                id: params.id,
            },
        })
            .then(() => {
            toast.success("Arquivo Deletado com sucesso", { draggablePercent: 60 });
            setGetFiles(true);
        })
            .catch((error) => {
            toast.error(error, { draggablePercent: 60 });
        });
    };
    const columns = [
        {
            field: "id",
            headerName: "id",
            width: 70,
            headerClassName: "table__header",
            hide: true,
        },
        {
            field: "tipo",
            headerName: "Tipo do Arquivo",
            width: 250,
            hide: windowDimensions.width < 800 ? true : false,
            cellClassName: "wrap",
        },
        {
            field: "fileName",
            headerName: "Descrição do Arquivo",
            flex: 1,
            minWidth: 140,
            cellClassName: "wrap",
        },
        {
            field: "ano",
            headerName: "Ano",
            hide: windowDimensions.width < 600 ? true : false,
            width: 60,
            cellClassName: "wrap",
        },
        {
            field: "extensao",
            headerName: "Tipo",
            hide: windowDimensions.width < 1368 ? true : false,
            width: 120,
            cellClassName: "wrap",
        },
        {
            field: "click",
            headerName: "Ações",
            flex: 1,
            maxWidth: 180,
            cellClassName: "wrap",
            hide: windowDimensions.width < 300 ? true : false,
            renderCell: (params) => {
                return (_jsxs(_Fragment, { children: [_jsx(Button, { style: { marginLeft: 5, padding: 5 }, className: `button__text ${backGroundColor ? 'highContrast borderContrast' : ''}`, onClick: () => handleDownload(params.row), variant: "contained", color: "warning", children: "Visualizar" }), _jsx(Button, { style: { marginLeft: 5, padding: 5 }, className: `button__text ${backGroundColor ? 'highContrast borderContrast' : ''}`, onClick: () => handleDelete(params.row), variant: "contained", color: "error", children: "Excluir" })] }));
            },
        },
    ];
    const handleSearchChange = (e) => {
        setInPageFilter(e.target.value);
        const value = e.target.value.toLowerCase();
        if (data) {
            const filterLines = data.filter((line) => {
                return (line.extensao.toLowerCase().includes(value) ||
                    line.fileName.toLowerCase().includes(value) ||
                    line.ano.toString().toLowerCase().includes(value));
            });
            setFilterData(filterLines);
        }
    };
    const VisuallyHiddenInput = styled("input") `
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    bottom: 0;
    left: 0;
    white-space: nowrap;
    width: 1px;
  `;
    return (_jsxs("div", { className: `page ${backGroundColor ? 'highContrast' : ''}`, children: [_jsx(ToastContainer, { draggable: true }), _jsxs("div", { className: "card__parent", children: [_jsx("div", { className: "title", children: _jsx("p", { children: `Publicação de Arquivos ${user.name}` }) }), !warningMessage && (_jsxs("div", { className: "", style: {
                            margin: "auto",
                            textAlign: "center",
                            paddingTop: "10px",
                            height: "50px",
                            color: "#31708f",
                            backgroundColor: "#d9edf7",
                            borderColor: "#bce8f1",
                            width: "50%",
                            display: `${selectedFile ? "none" : ""}`,
                            marginBottom: "10px",
                        }, children: [_jsx("strong", { children: "Informa\u00E7\u00E3o" }), " ", _jsx("br", {}), "Selecione um arquivo para realizar o upload!"] })), warningMessage && (_jsxs("div", { className: "", style: {
                            margin: "auto",
                            textAlign: "center",
                            paddingTop: "10px",
                            height: "50px",
                            color: "#31708f",
                            backgroundColor: "#ffe7e7",
                            borderColor: "#bce8f1",
                            width: "50%",
                            display: `${selectedFile ? "none" : ""}`,
                            marginBottom: "10px",
                        }, children: [_jsx("strong", { children: "Aviso" }), " ", _jsx("br", {}), _jsx("span", { dangerouslySetInnerHTML: { __html: warningMessage } })] })), _jsxs("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "row", marginBottom: "20px" }, children: [_jsxs("div", { className: "firstRow__field ", style: { flex: 2 }, children: [_jsx(InputLabel, { id: "tipoArquivo", className: "search__label search__label__tipoArquivo", style: { maxWidth: 80 }, children: "Tipo do arquivo" }), _jsxs(Select, { labelId: "tipoArquivo", id: "demo-simple-select", value: tipoArquivo, label: "\u00D3rg\u00E3o", onChange: (e) => {
                                            settipoArquivo(e.target.value);
                                        }, className: "firstRow__field__select", size: "small", children: [_jsx(MenuItem, { value: "ppa", children: "Plano Plurianual e Acompanhamento de Programas e A\u00E7\u00F5es" }), _jsx(MenuItem, { value: "ldo", children: "Lei de Diretrizes Or\u00E7ament\u00E1rias" }), _jsx(MenuItem, { value: "loa", children: "Lei Or\u00E7ament\u00E1ria Anual" }), _jsx(MenuItem, { value: "metas", children: "Anexos, metas riscos" }), _jsx(MenuItem, { value: "balanco", children: "Balan\u00E7o Geral" }), _jsx(MenuItem, { value: "balancete", children: "Balancete Financeiro" }), _jsx(MenuItem, { value: "patrimonio", children: "Patrim\u00F4nio Bens M\u00F3veis" }), _jsx(MenuItem, { value: "patrimonioImovel", children: "Patrim\u00F4nio Bens Im\u00F3veis" }), _jsx(MenuItem, { value: "programa", children: "Programas e A\u00E7\u00F5es - Conforme Art 3\u00BA,\u00A7 5\u00BA TAG 2018." }), _jsx(MenuItem, { value: "covid", children: "Combate ao CORONAV\u00CDRUS" })] })] }), _jsxs("div", { className: "firstRow__field ", style: { flex: 1 }, children: [_jsx(InputLabel, { id: "dtInicial", className: `search__label search__label__mes`, children: "Ano" }), _jsx(DatePicker, { inputFormat: "YYYY", value: dataInicial, onChange: (newvalue) => (newvalue ? setDataInicial(newvalue.toString()) : ""), views: ["year"], renderInput: (params) => _jsx(TextField, Object.assign({ size: "small" }, params)), className: `firstRow__field__dates`, minDate: moment("2010-01-01"), maxDate: moment("2025-12-31") })] }), _jsxs("div", { className: "firstRow__field ", style: { marginTop: 20, marginLeft: 20 }, children: [_jsxs(Button, { component: "label", variant: "contained", href: "#file-upload", disabled: disableButtons, children: [_jsx(FontAwesomeIcon, { icon: faFile, style: { marginRight: 7 } }), "Selecione o arquivo", _jsx(VisuallyHiddenInput, { type: "file", onChange: (e) => {
                                                    if (e.target && e.target instanceof HTMLInputElement && e.target.files) {
                                                        const file = e.target.files[0];
                                                        setSelectedFile(file);
                                                        setNomeFile(file.name);
                                                        // You can now use 'selectedFile' as the selected file.
                                                        // setSelectedFile(selectedFile);
                                                    }
                                                } })] }), _jsx("p", { style: { marginTop: 2 }, children: nomeFile })] })] }), _jsxs("div", { className: "flexRow", style: { display: "flex", flexDirection: "row" }, children: [_jsxs("div", { className: "flex__firstRow", style: { display: "flex", flexDirection: "column", margin: "0 10px" }, children: [_jsx(InputLabel, { id: "pesquisaAvancada", className: "search__label", style: { maxWidth: 180 }, children: "Nome do Arquivo a Ser Exibido" }), _jsx(TextField, { label: "", value: nomeFile, size: "small", type: "text", disabled: !selectedFile, className: "form__input", inputProps: {
                                            autoCapitalize: 'none',
                                            className: 'form__input'
                                        }, onChange: (e) => {
                                            setNomeFile(e.target.value);
                                        }, style: { width: 500, marginBottom: 20 } })] }), _jsx("div", { className: "button", style: { marginTop: 20, marginLeft: 20 }, children: _jsxs(Button, { variant: "contained", disabled: nomeFile === "" || selectedFile === undefined, onClick: handleUpload, children: [_jsx(FontAwesomeIcon, { icon: faUpload }), _jsx("span", { className: "p10_left", children: "Enviar" })] }) }), loading && _jsx(CircularProgress, {})] })] }), _jsx("div", { className: "title", children: _jsx("p", { children: `Arquivos Publicados` }) }), data && data.length > 0 && !loading && (_jsxs("div", { className: "table__container sm-center ", children: [_jsx("div", { className: "table__export__container flex m1", children: _jsxs("div", { className: "search__avancada flex--1", children: [_jsx("span", { id: "pesquisaAvancada", className: `search__text ${backGroundColor ? 'colorContrast' : ''}`, children: "Pesquisa Por:" }), _jsx("input", { value: inPageFilter, className: "search__input", onChange: (e) => handleSearchChange(e) })] }) }), _jsx("div", { className: `table ${backGroundColor ? 'colorContrast' : ''} `, id: "table", children: _jsx(_Fragment, { children: _jsx(DataGrid, { rows: filterData, initialState: {
                                    sorting: {
                                        sortModel: [{ field: "ano", sort: "desc" }],
                                    },
                                }, columns: columns, pageSize: pageSize, onPageSizeChange: (newPageSize) => setPageSize(newPageSize), rowsPerPageOptions: [10, 30, 50, 100], autoHeight: true, className: `table ${backGroundColor ? 'colorContrast' : ''} `, headerHeight: 45, pagination: true, localeText: customPtBRText(), onStateChange: (state) => {
                                    const visibleRows = state.filter.visibleRowsLookup;
                                    const visibleItems = [];
                                    for (const [id, value] of Object.entries(visibleRows)) {
                                        if (value === true) {
                                            visibleItems.push(id);
                                        }
                                    }
                                    const res = data.filter((item) => visibleItems.includes(item.id.toString()));
                                } }) }) })] })), _jsx(Footer, {})] }));
};
export default Publicar;
